module.exports = __webpack_public_path__ + "img/oldman_selected.bfc1da96.png";